import React, { FC } from 'react';

import { HeaderProps } from './types';

import { Wrapper, Title, Description } from './styled';

const Header: FC<HeaderProps> = ({ header, description, stopPropagation }) => (
  <Wrapper onClick={e => stopPropagation && e.stopPropagation()}>
    <Title>{header}</Title>
    {description && <Description>{description}</Description>}
  </Wrapper>
);

export default Header;
